import { Controller } from "@hotwired/stimulus"
import { createRoot } from "react-dom/client"
import { createElement } from "react"

// Support component names relative to this directory. import.meta.glob's key
// format (relative to this file vs. the project root) varies by Vite version,
// so normalize by extracting everything after the last "components/" segment
// rather than assuming a specific prefix.
const componentModules = import.meta.glob('../components/**/*.jsx', { eager: true })
const componentsByName = {}
for (const [globPath, mod] of Object.entries(componentModules)) {
  const name = globPath.replace(/^.*\/components\//, '').replace(/\.jsx$/, '')
  componentsByName[name] = mod.default || mod
}

export default class extends Controller {
  static values = { component: String, props: Object }

  connect() {
    const Component = componentsByName[this.componentValue]
    if (!Component) throw new Error(`Component not found: ${this.componentValue}`)

    this.root = createRoot(this.element)
    this.root.render(createElement(Component, this.propsValue))
  }

  disconnect() {
    this.root.unmount()
  }
}
